/**
 * Created by why on 2019/8/17.
 */
import axios from '@/libs/api.request'
export const getByCondition = (data) => {
  return axios.request({
    url: '/bettingRecord/getByCondition',
    params: data,
    method: 'get'
  })
}

export const getByTicketTypeCount = (data) => {
  return axios.request({
    url: '/bettingRecord/findTicketTypeCount',
    method: 'get',
    params: data
  })
}

export const getByPlayTypeCount = (data) => {
  return axios.request({
    url: '/bettingRecord/findByPlayTypeCount',
    method: 'get',
    params: data
  })
}

export const getByMoneyCount = () => {
  return axios.request({
    url: '/bettingRecord/findByMoneyCount',
    method: 'get'
  })
}

export const getBettingTrend = (data) => {
  return axios.request({
    url: '/bettingRecord/selectBettingTrend',
    params: data,
    method: 'get'
  })
}

export const save = (data) => {
  return axios.request({
    url: '/bettingRecord/save',
    params: data,
    method: 'post'
  })
}

export const edit = (data) => {
  return axios.request({
    url: '/bettingRecord/edit',
    params: data,
    method: 'post'
  })
}

export const delByIds = (ids) => {
  return axios.request({
    url: `/bettingRecord/delByIds/${ids}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/betting-record-manage.js